import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const frDateTime = (iso) =>
  (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "jamais");
const MONTHS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
const frMonth = (ym) => `${MONTHS[Number(ym.slice(5, 7)) - 1]} ${ym.slice(0, 4)}`;

export default function IcalStatus({ reloadKey }) {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get("/admin/ical-status")
    .then((r) => setRows(r.data)).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load, reloadKey]);

  if (!rows) return <p className="text-xs text-muted-foreground">Chargement du diagnostic…</p>;

  return (
    <div className="border-t border-white/10 pt-5" data-testid="ical-status">
      <h4 className="text-sm font-semibold text-bone">État des imports</h4>
      <p className="mt-1 text-[11px] leading-relaxed text-muted-foreground">
        Nombre de nuits importées depuis chaque plateforme. Si Booking.com affiche « lien non
        renseigné », ses réservations ne peuvent pas apparaître sur le site : collez son lien iCal
        ci-dessus puis cliquez sur « Synchroniser ».
      </p>
      {rows.map((r) => (
        <div key={r.gite_slug} className="mt-3 bg-white/5 p-3 text-[11px]" data-testid={`ical-status-${r.gite_slug}`}>
          <p className="font-medium text-bone">{r.gite_name}</p>
          <p className="mt-1 text-muted-foreground">Dernière synchronisation : {frDateTime(r.last_sync)}</p>
          {[["airbnb", "Airbnb", r.airbnb_configured], ["booking", "Booking.com", r.booking_configured]]
            .map(([key, label, configured]) => (
              <p key={key} className={`mt-1 ${r.errors?.[key] ? "text-destructive" : configured ? "text-bone" : "text-muted-foreground"}`}
                data-testid={`ical-source-${key}-${r.gite_slug}`}>
                {label} : {!configured
                  ? "lien non renseigné"
                  : r.errors?.[key]
                    ? `erreur — ${r.errors[key]} (dernières nuits connues conservées)`
                    : `${r.counts?.[key] ?? 0} nuit(s) importée(s)`}
              </p>
            ))}
          {!!Object.keys(r.by_month || {}).length && (
            <p className="mt-1.5 text-muted-foreground" data-testid={`ical-months-${r.gite_slug}`}>
              Par mois : {Object.entries(r.by_month).map(([m, n]) => `${frMonth(m)} ${n}`).join(" · ")}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
